import {createBrowserHistory} from 'history';
import swal from 'sweetalert';

export const apiBaseUrl = 'https://ordera-api.cap-tek.com:9094/api';

export const apiClient =async(url,option={})=>{
    const {method,body} = option
    const request = new Request(`${apiBaseUrl}/${url}`,{
        method,
        headers: new Headers({'Content-Type': 'aplication/json','x-auth-token': sessionStorage.getItem('adminDetails')? JSON.parse(sessionStorage.getItem('adminDetails')).token:''}),
        body:JSON.stringify(body)
    })
    const res = await fetch(request);
    const status = res.status;

    if (status === 500 || status === 405) {
        setToastAlert({ ResponseText: 'Internal Server Error', status })
        return status;
    }
    const response = await res.json();
    const data = { ...response, status };
    
    console.log("response",data)
    if (status !== 200 || apiSuccessActions.includes(url)) {
        const { status, ResponseText } = data;
        const type = status === 200 ? "success" : "error";
        const message =
                status !== 200
                ? data.msg[0]
                : ResponseText;
        setToastAlert({ type, message });
    }

    if (status === 401) {
        sessionStorage.clear();
        window.location.href = "/admin-login";
        return;
    }

    return data;
}

const apiSuccessActions = [
    "active-deactive-user",
    "update-user",
    "delete-user",
    "add-category",
    "delete-category",
    "update-category",
    "add-product",
    "update-product",
    "add-seller",
    "seller-update",
    "add-store",
    "update-store",
    "delete-store",
    
];

const setToastAlert = ({ type, message }) => {
    swal("", message, type);
};
export const history = createBrowserHistory();
